import { useCallback } from 'react';
import { cx } from '@linaria/core';
import { InputField } from 'components/ui_library/Formik';
import { useFormikContext } from 'formik';
import { selectModelTypeFieldTypeInfo } from 'modules/Models/components/ModelForm/utils/utils';
import { formContainer, inputContainer, inputStyle, textGenInputStyle } from 'modules/Models/components/ModelForm/styles';
import { FormikInitialValues } from 'modules/Models/components/ModelForm/utils/types';
import { TEXT_GEN_MODEL_TYPES } from 'modules/Models/types';
import { FormLabel } from './FormLabel';
import { maxNumberFormElementStyled } from './MaxNumberFormElement.styled';
type MaxNumberFormElementProps = React.InputHTMLAttributes<HTMLInputElement> & {
  field?: CF.API.Models.ModelTypeFieldsEntity;
  path: string;
};
export const MaxNumberFormElement = ({
  path,
  field,
  disabled
}: MaxNumberFormElementProps) => {
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const {
    fieldValueMap,
    modelType
  } = (values as FormikInitialValues);
  const {
    description = '',
    placeholder = '',
    default_value = ''
  } = selectModelTypeFieldTypeInfo(path, (values as FormikInitialValues), field);
  const inputValue = (fieldValueMap[path] as string);
  const isTextGenView = TEXT_GEN_MODEL_TYPES.includes(modelType);
  const onChange = useCallback(e => {
    // Remove leading zeros from the value if followed by a digit
    const stringValue = e.target.value.replace(/^0+(?=\d)/g, '');
    const finalValue = stringValue.includes('.') ? Number.parseFloat(stringValue) : Number.parseInt(stringValue, 10);
    if (Number.isNaN(finalValue)) {
      setFieldValue('errorDetails', 'Please check the form for incorrect values');
      setFieldValue('errorDescription', 'Invalid fields');
    } else {
      setFieldValue('errorDetails', undefined);
      setFieldValue('errorDescription', undefined);
    }
    setFieldValue('fieldValueMap', {
      ...fieldValueMap,
      [path]: Array.isArray(default_value) ? [e.target.value] : finalValue
    });
  }, [fieldValueMap, path]);
  const handleOnBlur = useCallback(() => {
    if (inputValue === '') {
      setFieldValue('fieldValueMap', {
        ...fieldValueMap,
        [path]: 0
      });
    }
  }, [fieldValueMap, path]);
  return <div className={formContainer}>
      <div className={inputContainer}>
        <FormLabel path={path} description={(description as string)} />
        <div className={cx(inputStyle, isTextGenView && textGenInputStyle)}>
          <InputField name="input" type="number" min="0" id={path} placeholder={placeholder} value={(inputValue as string)} onChange={onChange} onBlur={handleOnBlur} disabled={disabled} className={maxNumberFormElementStyled} />
          {isTextGenView && description && <span className="description">{description}</span>}
        </div>
      </div>
    </div>;
};